class ProductCardQuickAdd extends HTMLElement {
	connectedCallback() {
		this.abortController = new AbortController();
		const { signal } = this.abortController;

		this.addEventListener(
			'click',
			(event) => {
				const trigger = event.target.closest('[data-card-size-chart]');
				if (!trigger) return;

				// Finish closing the size popover before the native modal opens.
				event.preventDefault();
				event.stopPropagation();
				this.showSizeChart(trigger);
			},
			{ signal },
		);

		// Set the chosen variant before the native product-form handles the submit.
		this.addEventListener(
			'submit',
			(event) => {
				const button = event.submitter;
				if (!button?.dataset.variantId || button.disabled || button.getAttribute('aria-busy') === 'true') {
					event.preventDefault();
					event.stopImmediatePropagation();
					return;
				}
				event.target.elements.namedItem('id').value = button.dataset.variantId;
			},
			{ capture: true, signal },
		);

		this.addEventListener(
			'variant:add',
			() => {
				if (window.themeVariables.settings.cartType === 'drawer') {
					this.closest('x-popover').hide();
				}
			},
			{ signal },
		);
	}

	disconnectedCallback() {
		this.abortController.abort();
	}

	async showSizeChart(trigger) {
		const modal = document.getElementById(trigger.getAttribute('aria-controls'));
		const popover = this.closest('x-popover');
		if (!modal || this.openingSizeChart) return;

		this.openingSizeChart = true;
		try {
			await popover.hide();
			if (!popover.isConnected) return;

			// This listener survives the native popover's mobile reparenting.
			const closed = new Promise((resolve) =>
				modal.addEventListener('dialog:after-hide', resolve, { once: true }),
			);
			await modal.show();
			await closed;

			if (popover.isConnected) {
				await popover.show();
			}
		} finally {
			this.openingSizeChart = false;
		}
	}
}

if (!customElements.get('product-card-quick-add')) {
	customElements.define('product-card-quick-add', ProductCardQuickAdd);
}
